/**
 * @ignore
 * Created by shanie on 3/8/17.
 */

import { useState } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';
import PropTypes from 'prop-types';

import HeartFilledIcon from 'dibs-icons/exports/HeartFilled';

// Styles
import classnames from 'classnames';
import styles from './Heart-Styles.scss';

const messages = defineMessages({
    label: {
        id: 'dibs-portfolio-heart.HeartIconWrapper.label',
        defaultMessage: 'Save to favorites',
    },
});

const HeartIconWrapper = props => {
    const intl = useIntl();
    const [isActive, setIsActive] = useState(false);
    const className = classnames(styles.heart, props.className, {
        [styles[props.type]]: props.type,
    });
    const iconClasses = classnames(styles.icon, {
        [styles.isAnimated]: props.isAnimated,
        [styles.isFilled]: props.isFilled,
        [styles.isStrokeWidthHeavy]: props.isStrokeWidthHeavy,
        [styles.hoverClass]: props.useHoverClass,
    });

    const dataTn = props.isFavorited ? 'item-saved-icon' : 'item-save-icon';

    function toggleActive(active) {
        if (props.type === 'button') {
            setIsActive(active);
        }
    }

    return (
        <button
            aria-label={intl.formatMessage(messages.label)}
            className={classnames(
                styles.iconWrapper,
                {
                    [styles[props.type]]: props.type,
                    [styles.isActive]: isActive,
                },
                props.buttonClass
            )}
            onClick={props.onClick}
            onTouchStart={() => toggleActive(true)}
            onTouchEnd={() => toggleActive(false)}
            data-tn={dataTn}
        >
            <div className={className} onAnimationEnd={props.onAnimationEnd}>
                <HeartFilledIcon className={iconClasses} />
            </div>
        </button>
    );
};

HeartIconWrapper.defaultProps = {
    isFavorited: false,
    type: 'outline',
    isStrokeWidthHeavy: false,
    useHoverClass: false,
};

HeartIconWrapper.propTypes = {
    className: PropTypes.string,
    buttonClass: PropTypes.string,
    isStrokeWidthHeavy: PropTypes.bool,
    isAnimated: PropTypes.bool,
    isFavorited: PropTypes.bool,
    isFilled: PropTypes.bool,
    useHoverClass: PropTypes.bool,
    onClick: PropTypes.func,
    onAnimationEnd: PropTypes.func,
    type: PropTypes.oneOf(['outline', 'button']),
};

export default HeartIconWrapper;
